export const ApplicationBrand = {
    brandName: ' E-TRaide - HQ',
    brandImage: '/brand.png'
};

export const MenuItems = {
    "applicationItem": {
        "data": [
            {
                parentID: 1,
                item: [
                    {
                        itemTitle: "Overview",
                        itemList: [
                            {
                                id: '1',
                                name: "Dashboard",
                                icon: "/Images/dashboard.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            },
                        ]
                    },
                    {
                        itemTitle: "Summary Reports",
                        itemList: [
                            {
                                id: '2',
                                name: "Coverage Summary Report",
                                icon: "/Images/graph-bar.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            },
                            {
                                id: '3',
                                name: "Attendance Report",
                                icon: "/Images/outline-inventory.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            },
                        ]
                    }
                ]
            }
        ]
    }
};

export const ApplicationItems = {
    "applications": [
      {
        name: "Coverage",
        icon: "/Images/graph-bar.svg",
        modules: [
          {
            id: 8,
            name: "Dashboard",
            icon: "/Images/dashboard.svg",
            roleLevel: "0",
            path: "/dashboards",
            children: [
              {
                menuHeader: "Overview"
              },
              {
                id: 1,
                name: "Dashboard",
                icon: "/Images/dashboard.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                menuHeader: "Summary Reports"
              },
              {
                id: 2,
                name: "Coverage Summary Report",
                icon: "/Images/graph-bar.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                id: 3,
                name: "Attendance Report",
                icon: "/Images/outline-inventory.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
            ]
          }
        ]
      }
    ]
  }